// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const storePickup: Styleguide["storePickup"] = {};

export default storePickup;
